import api from "@/axios";
import type { AxiosResponse } from "axios";
import type {PackingList} from "@/types/packingList-types";

export const addOrderPackingList = async (data: PackingList): Promise<PackingList> => {
  const response = await api.post('/orders/packing-lists', data)
  return response.data
}

export const getPackingList = async (): Promise<any> => {
    const response = await api.get("/packing-lists");
    return response.data;
}

export const getPackingListById = async (id: string): Promise<any> => {
    const response = await api.get(`/packing-lists/${id}`);
    return response.data;
}

export const dispatchPackingList = async (id: string, data: any): Promise<AxiosResponse> => {
    const response = await api.patch(`/packing-lists/${id}/dispatch`, data);
    return response.data;
};

export const deliverPackingList = async (id: string, data: any): Promise<AxiosResponse> => {
    const response = await api.patch(`/packing-lists/${id}/deliver`, data);
    return response.data;
};

export const getInvoiceByPackingListId = async (packingListId: string) => {
    const response = await api.get(`/invoices/${packingListId}`)
    return response.data
}